import { render, staticRenderFns } from "./OnboardingRedirect.vue?vue&type=template&id=dc01be2e&"
import script from "./OnboardingRedirect.vue?vue&type=script&lang=js&"
export * from "./OnboardingRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports